var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_4209",
  "data-name": "Group 4209",
  transform: "translate(-730 -30)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4207",
  "data-name": "Group 4207",
  transform: "translate(103 78)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_1",
  "data-name": "Ellipse 1",
  cx: 8,
  cy: 8,
  r: 8,
  transform: "translate(627 -48)",
  fill: "#ff6000"
}), /*#__PURE__*/React.createElement("path", {
  id: "flag_FILL0_wght400_GRAD0_opsz48",
  d: "M200-790.247V-800h4.92l.273,1.233h3.414v5.307h-3.672l-.272-1.219h-3.8v4.432ZM204.3-796.73Zm1.363,2.409h2.08v-3.586h-3.284l-.273-1.234h-3.328v3.6h4.532Z",
  transform: "translate(430.697 755.123)",
  fill: "#fff"
})))));
export default __webpack_public_path__ + "static/media/ndrCircle.0640b2fa.svg";
export { SvgComponent as ReactComponent };